import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import './PricingHeader.css';

const PricingHeader = ({ billingCycle, setBillingCycle, currency, setCurrency }) => {
  return (
    <div className="text-center mb-5">
      {/* <h2 className="mb-4">Choose Your Plan</h2> */}
      
      <div className="d-flex justify-content-center gap-3">
        {/* Billing Cycle Toggle */}
        <ButtonGroup>
          <Button
            variant={billingCycle === 'monthly' ? 'primary' : 'outline-primary'}
            onClick={() => setBillingCycle('monthly')}
          >
            Monthly
          </Button>
          <Button
            variant={billingCycle === 'yearly' ? 'primary' : 'outline-primary'}
            onClick={() => setBillingCycle('yearly')}
          >
            Yearly
          </Button>
        </ButtonGroup>

        {/* Currency Toggle */}
        <ButtonGroup>
          <Button
            variant={currency === 'USD' ? 'primary' : 'outline-primary'}
            onClick={() => setCurrency('USD')}
          >
            USD
          </Button>
          <Button
            variant={currency === 'INR' ? 'primary' : 'outline-primary'}
            onClick={() => setCurrency('INR')}
          >
            INR
          </Button>
        </ButtonGroup>
      </div>

      {billingCycle === 'yearly' && (
        <div className="text-success mt-2">
          <small>Save up to 10% with yearly billing</small>
        </div>
      )}
    </div>
  );
};

export default PricingHeader;